import Button, {ButtonVariant} from "@/app/_components/Button";
import UserInfo from "@/app/types/UserInfo";
import {useState} from "react";
import {Heading} from "react-aria-components";
import RadioGroup from "@/app/_components/forms/RadioGroup";
import Radio from "@/app/_components/forms/Radio";
import StudentModalBody from "./StudentModalBody";

const NonAcademyUserModalBody = ({
	userInfo,
	closeModal,
}: {
	userInfo: UserInfo;
	closeModal: () => void;
}) => {
	const [selectedOption, setSelectedOption] = useState<
		"parent" | "student" | null
	>(null);
	const [isStudent, setIsStudent] = useState(false);
	if (isStudent) {
		return <StudentModalBody />;
	}
	return (
		<div className="flex flex-col gap-6 px-4 py-10">
			{userInfo.first_name ? (
				<>
					<Heading level={2}>Hi {userInfo.first_name}!</Heading>
					<p className="text-body-3">Welcome to AoPS Academy.</p>
				</>
			) : (
				<Heading level={2}>Welcome to AoPS Academy!</Heading>
			)}
			<p className="text-body-2">
				Before proceeding, we need to know if you&apos;re logged in as a parent
				or student.
			</p>
			<RadioGroup
				className="flex flex-col gap-2"
				isRequired
				hideLabelDecorators
				value={selectedOption}
				onChange={(value) => setSelectedOption(value as "parent" | "student")}
				labelText="Please select one of the options below:"
			>
				<Radio className="cursor-pointer" value="parent">
					Parent
				</Radio>
				<Radio className="cursor-pointer" value="student">
					Student
				</Radio>
			</RadioGroup>
			<div className="flex justify-end">
				<Button
					variant={ButtonVariant.NAVY}
					onClick={() => {
						if (selectedOption === "parent") {
							closeModal();
						} else if (selectedOption === "student") {
							setIsStudent(true);
						}
					}}
					disabled={!selectedOption}
				>
					Continue
				</Button>
			</div>
		</div>
	);
};

export default NonAcademyUserModalBody;
